import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

export const CoachingDetails = () => {
  return (
    <section className="relative w-full bg-gradient-to-br from-brand-primary/5 to-brand-secondary/5 py-4 pt-48">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center space-y-6">
          <h1 className="text-4xl md:text-5xl font-bold text-brand-primary">
            Her Anında Yanındayız
          </h1>
          
          <p className="text-lg text-text-secondary leading-relaxed">
          Türkiye’nin en iyi üniversitelerine yerleşmiş tecrübeli koç ekibimiz, sizlere bu yolda eşlik etmek ve onların yaptığı gibi, hayallerinizi gerçekleştirmeniz için buradalar.
          <br />
          <b>Sana en uygun koçunu seç, ve birlikte çalışmaya başla!</b>
          </p>

          <div className="flex flex-wrap justify-center gap-4 mt-8">
            <Button 
              variant="default"
              className="bg-brand-primary hover:bg-brand-primary/90 text-white"
              onClick={() => window.location.href = '/yks-koclugu'}
            >
              Koçluğumuz Nasıl Çalışır?
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
            
            <Button 
              variant="outline"
              className="border-brand-primary text-brand-primary hover:bg-brand-primary/5"
              onClick={() => window.location.href = '/koc-oner'}
            >
              Bana Koç Öner
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};